import { render, staticRenderFns } from "./OrderCreatedStats.vue?vue&type=template&id=20d023e4"
import script from "./OrderCreatedStats.vue?vue&type=script&lang=js"
export * from "./OrderCreatedStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports